jQuery( function($) {

    $('.js-slider-equipo').each(function(i,el){
        var $this = $(el);
        var $hidden_controls = $this.find('.js-slider-equipo__control.hidden');
        var $showAll = $this.find('.js-slider-equipo__showAll');

        $showAll.on('click', function(){
            $showAll.slideReplace( $hidden_controls );
        });

    });

    $('.accordion-equipo.js-accordion').each(function(i,el){
        const $this = $(el);
        const $hidden_controls = $this.find('.accordion-equipo__item.hidden');
        var $showAll = $this.find('.js-slider-equipo__showAll');

        $showAll.on('click', function(){
            $showAll.hide();
            $hidden_controls.css('display', 'grid');
        });
    });

});
